import { sortIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Sort = createIcon({
  displayName: 'Sort',
  paths: [
    'M339.174 183.152l181.035 181.035c16.683 16.64 16.683 43.648 0 60.331s-43.648 16.682-60.331 0l-108.203-108.203v494.335c0 23.595-19.072 42.667-42.667 42.667-23.552 0-42.667-19.072-42.667-42.667v-494.335l-108.16 108.203c-16.683 16.682-43.691 16.682-60.331 0-16.683-16.683-16.683-43.691 0-60.331l180.992-181.035c16.683-16.64 43.691-16.64 60.331 0zM865.835 599.479c16.683-16.683 43.648-16.683 60.331 0s16.683 43.648 0 60.331l-181.035 181.035c-16.64 16.64-43.648 16.64-60.331 0l-180.992-181.035c-16.683-16.683-16.683-43.648 0-60.331 16.64-16.683 43.648-16.683 60.331 0l108.16 108.203v-494.335c0-23.595 19.115-42.667 42.667-42.667 23.595 0 42.667 19.072 42.667 42.667v494.335l108.203-108.203z'
  ],
  canvasPaths: canvasIconPaths(sortIcon)
})
